<template>
	<div class="container-xl">
		<main class="py-4">
			<div class="row g-3 mb-4 align-items-center justify-content-between">
				<div class="col-auto">
					<h1 class="app-page-title mb-0">{{ __('schedules.manage-schedules-title') }}</h1>
				</div>
				<div class="col-auto">
					<div class="page-utilities">
						<div class="row g-2 justify-content-start justify-content-md-end align-items-center">
							<div class="col-auto">
								<a class="btn app-btn-secondary" href="/schedules/create">
									<svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
										<path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
									</svg>
									{{ __('schedules.add-schedule') }}
								</a>
							</div>
                            <div class="col-auto">
								<a class="btn app-btn-secondary" href="/import-schedule">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
										<path stroke-linecap="round" stroke-linejoin="round" d="M7.5 7.5h-.75A2.25 2.25 0 004.5 9.75v7.5a2.25 2.25 0 002.25 2.25h7.5a2.25 2.25 0 002.25-2.25v-7.5a2.25 2.25 0 00-2.25-2.25h-.75m0-3l-3-3m0 0l-3 3m3-3v11.25m6-2.25h.75a2.25 2.25 0 012.25 2.25v7.5a2.25 2.25 0 01-2.25 2.25h-7.5a2.25 2.25 0 01-2.25-2.25v-.75" />
									</svg>
									{{ __('schedules.import-schedule') }}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
            <div class="row g-3 mb-4 align-items-center justify-content-between">
				<div class="col-auto">
					<div class="page-utilities">
						<div class="row g-2 justify-content-start justify-content-md-end align-items-center">
                            <div class="col-auto">
                                <h6 class="mb-0">Filters:</h6>
                                <button class="btn btn-extra-sm btn-success" @click="clearFilters()">reset</button>
                            </div>
                            <div class="col-auto">
					            <input type="text" v-model="filters.textSearchFilter" v-on:keyup.enter="getSchedules" style="width:260px;" class="form-control" placeholder="Zoek op (bedrijfs)naam of locatie">
					        </div>
                            <div class="col-auto">
							    <select class="form-select w-auto" v-model="filters.instructorFilter" @change="getSchedules">
								    <option value="all">{{ __('schedules.instructorfilter-all') }}</option>
                                    <option v-for="instructor in instructors" v-bind:key="instructor.id" v-bind:value="instructor.id">{{ instructor.name }}</option>
								</select>
                            </div>
                            <div class="col-auto">
							    <select class="form-select w-auto" v-model="filters.questionnaireFilter" @change="getSchedules">
								    <option value="all">{{ __('schedules.questionnairefilter-all') }}</option>
                                    <option v-for="questionnaire in questionnaires" v-bind:key="questionnaire.id" v-bind:value="questionnaire.id">{{ questionnaire.name }}</option>
								</select>
                            </div>
                            <div class="col-auto">
							    <select class="form-select w-auto" v-model="filters.dateFilter" @change="getSchedules">
								    <option value="today">{{ __('schedules.datefilter-today') }}</option>
                                    <option value="tomorrow">{{ __('schedules.datefilter-tomorrow') }}</option>
                                    <option value="tomorrow+1">{{ __('schedules.datefilter-tomorrow+1') }}</option>
                                    <option value="tomorrow+2">{{ __('schedules.datefilter-tomorrow+2') }}</option>
									<option value="yesterday">{{ __('schedules.datefilter-yesterday') }}</option>
									<option value="prev7days">{{ __('schedules.datefilter-prev7days') }}</option>
									<option value="next7days">{{ __('schedules.datefilter-next7days') }}</option>
                                    <option value="next30days">{{ __('schedules.datefilter-next30days') }}</option>
                                    <option value="next60days">{{ __('schedules.datefilter-next60days') }}</option>
                                    <option value="next90days">{{ __('schedules.datefilter-next90days') }}</option>
                                    <option value="thismonth">{{ __('schedules.datefilter-thismonth') }}</option>
                                    <option value="prevmonth">{{ __('schedules.datefilter-prevmonth') }}</option>
                                    <option value="thisyear">{{ __('schedules.datefilter-thisyear') }}</option>
                                    <option value="prevyear">{{ __('schedules.datefilter-prevyear') }}</option>
                                    <option value="nextyear">{{ __('schedules.datefilter-nextyear') }}</option>
								</select>
                            </div>
                             <div class="col-auto">
                                <select class="form-select w-auto" v-model="filters.sort" @change="getSchedules">
								    <option value="date-desc">{{ __('schedules.sortfilter-date-desc') }}</option>
                                    <option value="date-asc">{{ __('schedules.sortfilter-date-asc') }}</option>
                                    <option value="companyname-desc">{{ __('schedules.sortfilter-companyname-desc') }}</option>
                                    <option value="companyname-asc">{{ __('schedules.sortfilter-companyname-asc') }}</option>
                                    <option value="location-desc">{{ __('schedules.sortfilter-location-desc') }}</option>
                                    <option value="location-asc">{{ __('schedules.sortfilter-location-asc') }}</option>
								</select>
						    </div>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-12 mb-2"  v-if="schedules">
					<div class="app-card app-card-orders-table shadow-sm mb-5">
						<div class="app-card-body">
							<div class="table-responsive">
								<table class="table app-table-hover mb-0 text-left">
									<thead>
									<tr>
										<th class="cell">{{ __('form.instructor-name-single') }}</th>
										<th class="cell">{{ __('form.company-name') }}</th>
										<th class="cell">{{ __('form.participant-name-single') }}</th>
										<th class="cell">{{ __('form.location') }}</th>
										<th class="cell">{{ __('form.session-date-time') }}</th>
										<th class="cell">{{ __('form.questionnaire') }}</th>
										<th class="cell">{{ __('form.actions') }}</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="schedule in schedules" :key="schedule.id + schedule.updated_at">
										<td class="cell">{{ schedule.instructor.name }}</td>
										<td class="cell">{{ schedule.company_name }}
                                            <span v-if="schedule.project_code !== null">
                                                ({{ schedule.project_code }})
                                            </span>
                                        </td>
										<td class="cell">{{ schedule.participant_name }}</td>
										<td class="cell">{{ schedule.location }}</td>
										<td class="cell">{{ schedule.start_date_formatted }}</td>
										<td class="cell">{{ schedule.questionnaire ? schedule.questionnaire.name : '-' }}</td>
										<td class="cell">
											<button class="btn btn-sm btn-outline-success" @click="viewSchedule(schedule)">{{ __('actions.view') }}</button>
											<a class="btn btn-sm btn-outline-success" :href="'/schedules/' + schedule.id + '/edit'">{{ __('actions.edit')   }}</a>
											<a class="btn btn-sm app-btn-danger" href="#" @click.prevent="deleteSchedule(schedule)">{{ __('actions.delete') }}</a>
                                            <a v-if="schedule.filled_questionnaire_id" class="btn btn-sm btn-outline-success" download="true" @click.prevent="download('/forms/get-pdf/' + schedule.filled_questionnaire_id)">PDF</a>
										</td>
									</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<pagination-component :pagination="pagination" @paginate="getSchedules()"></pagination-component>
				</div>

				<div class="col-md-12"  v-else>
					<div class="app-card alert alert-dismissible shadow-sm mb-5 border-left-decoration" role="alert">
						<div class="inner">
							<div class="app-card-body p-3 p-lg-4">
								<h3 class="mb-3">{{ __('schedules.no-schedules-title') }}</h3>
								<p>{{ __('schedules.no-schedules-text') }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
		<view-schedule-modal ref="viewScheduleModal"></view-schedule-modal>
	</div>
</template>

<script>
export default {
	name: "ScheduleComponent",

	props: {
		instructors: {
			type: Array,
			required: true
		},

		questionnaires: {
			type: Array,
			required: true
		},
	},

	data() {
		return {
			schedules: null,
			pagination: {
                current_page: 1
            },
            filters: this.getFiltersFromStorage()
		}
	},

	created() {
		this.schedules = this.getSchedules()
	},

	methods: {
        download (path) {
            window.open(path, "_self");
            setTimeout(() =>  this.getSchedules(), 500);
        },

        getFiltersFromStorage: function(clear = false){

            if (clear)
            {
                sessionStorage.removeItem('schedulefilters');
            }
            else
            {
                if (sessionStorage.getItem('schedulefilters')) {
                    try {
                        return JSON.parse(sessionStorage.getItem('schedulefilters'));

                    } catch(e) {
                        sessionStorage.removeItem('schedulefilters');
                    }
                }
            }

            return {
                instructorFilter: 'all',
                questionnaireFilter: 'all',
                dateFilter: 'next90days',
                textSearchFilter: '',
                sort: 'date-asc'
            }
        },

        clearFilters: function (){
            this.filters = this.getFiltersFromStorage(true);
            this.getSchedules();
        },

		getSchedules: function (){

            sessionStorage.setItem('schedulefilters', JSON.stringify(this.filters));

			axios.get('/get-schedules', {
                        params: {
                            page: this.pagination.current_page,
                            datefilter: this.filters.dateFilter,
                            instructorfilter: this.filters.instructorFilter,
                            questionnairefilter: this.filters.questionnaireFilter,
                            textsearchfilter: this.filters.textSearchFilter,
                            sort: this.filters.sort
                        }
                    })
				.then(response => {
					this.schedules = response.data.schedules.data
					this.pagination = response.data.schedules
				}).catch(error => {
					console.log(error)
				})
		},

		deleteSchedule: function(schedule) {
			Swal.fire({
				title: this.__('actions.confirm'),
				text: this.__('actions.confirm-text'),
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText:  this.__('actions.confirm-yes'),
				cancelButtonText:  this.__('actions.confirm-no'),
				showLoaderOnConfirm: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				reverseButtons: true,
				preConfirm: login => {
					return axios.delete(`/schedules/${schedule.id}`).then(response => {
						return response.data
					})
						.catch(error => {
							Swal.showValidationMessage(`Something went Wrong!: ${error}`)
						})
				},
				allowOutsideClick: () => !Swal.isLoading()
			}).then(result => {
				if (result.value) {
					Toast.fire({icon: 'success', title: result.value.message})
					this.getSchedules()
				}
			})
		},

		editSchedule: function(schedule) {
			this.$refs.addScheduleModal.edit(schedule);
		},

		viewSchedule: function(schedule) {
			this.$refs.viewScheduleModal.view(schedule);
		},
	}
}
</script>

<style scoped>
.btn-extra-sm{
    font-weight: 500;
    padding: 0.1rem 0.5rem;
    font-size: 0.70rem;
    text-transform: uppercase;
    color: #fff;
}

</style>
